/**
 * <ProfileInfo  />
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames';
import './ProfileInfo.scss';

class ProfileInfo extends React.Component {
  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props) {
    super(props);
  }

  componentWillMount() {

  }
  
  render() {
    let {
      name,
      picture,
      pictureHeight = 5,
      pictureWidth = 5,
    } = this.props;

    return (
      <div className='profile-info'>
        <img className='profile-picture' src={picture} width={pictureWidth} height={pictureHeight} />
        <div className='profile-text'> {name}</div>
      </div>
    )
  }
}

export default ProfileInfo;



// WEBPACK FOOTER //
// ./src/shared/PosterView/ProfileInfo.js